export default __webpack_public_path__ + "static/media/Panthers.787ca14d.png";